module.exports = __webpack_public_path__ + "img/9788971969298.bc551e3e.jpg";